import { debounce as debounceFn } from "@/util/common";
import {selected} from '.'

function pageFactory({debounce} = {}) {
  return {
    mixins: [selected],
    data() {
      return {
        pageSearch: {
          current: 1,
          size: 10,
          search: {}
        },
        page: {
          total: 0,
          records: []
        }
      }
    },
    methods: {
      handleCurrentChange(current) {
        this.pageSearch.current = current;
      },
      handleSizeChange(size) {
        this.pageSearch.size = size;
      },
      reQueryByPage() {
        if (this.pageSearch.current === 1) {
          this.executeQueryByPage();
        } else {
          this.pageSearch.current = 1;
        }
      },
      queryByPage(pageSearch) {
        console.warn(`implement queryByPage`, pageSearch);
      },
      executeQueryByPage() {
        if (this._debounce_queryByPage == null) {
          if (debounce != null && debounce > 0) {
            this._debounce_queryByPage = debounceFn(function(pageSearch) {
              this.queryByPage(pageSearch);
            }, debounce);
          } else {
            this._debounce_queryByPage = this.queryByPage;
          }
        }
        this._debounce_queryByPage(this.pageSearch);
      },
    },
    watch: {
      'pageSearch.search': {
        immediate: true,
        deep: true,
        handler() {
          console.log(`search change`);
          this.reQueryByPage();
        }
      },
      'pageSearch.current': {
        deep: false,
        handler() {
          this.executeQueryByPage();
        },
      },
      'pageSearch.size': {
        deep: false,
        handler() {
          this.reQueryByPage();
        },
      },
      page: {
        deep: true,
        handler(value) {
          if (value.total > 0) {
            this.select(value.records[0]);
          }
        },
      },
    }
  }
}

export { pageFactory }

export default pageFactory()